<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`应收账款`)">导出</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total"
      :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <!-- <template slot="etime" slot-scope="params">
        <div v-if="params.params.etime == 2" class="overTime type0">
          即将到期
        </div>
        <div v-if="params.params.etime == 3" class="overTime type1">
          暂未到期
        </div>
        <div v-if="params.params.etime == 1" class="overTime type2">
          已逾期
        </div>
      </template> -->
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import Wxts from '../../../components/Wxts.vue';
export default {
  name: "FinanceInitialPayment",
  mixins: [tableMixin],
  components: { Wxts },
  data() {
    return {
      baseUrl: 'custom',
      getListUrl: 'freightrec',
      breadcrumb: [
        { name: "财务管理" },
        { name: "应收账款管理" },
      ],
      wxtsList: [
        {
          name: '欠款金额=公司运费总额-亏吨金额+补差金额+合同补差-还款金额之和'
        }
      ],
      formInline: {},
      formCtrl: [
        // {
        //   label: "月份：",
        //   keyName: "month",
        //   placeholder: "请选择月份",
        //   type: "month",
        // },
        {
          label: "公司名称",
          keyName: "name",
          placeholder: "请填写公司名称",
          type: "text",
        },
        // {
        //   label: "联系人",
        //   keyName: "member",
        //   placeholder: "请填写联系人",
        //   type: "text",
        // },
        {
          label: "欠款状态",
          keyName: "intimes",
          placeholder: "请选择",
          type: "select",
          options: [
            { label: '全部', value: '' },
            { label: '已逾期', value: 1, },
            { label: '即将到期', value: 2, },
            { label: '暂未到期', value: 3, },
          ],
        },
      ],
      cols: [
        { keyName: "name", label: "公司名称", minwidth: 150 },
        { keyName: "member", label: "联系人", minwidth: 110 },
        { keyName: "address", label: "公司地址", minwidth: 130 },
        { keyName: "phone", label: "联系电话", minwidth: 120 },
        { keyName: "repaytime", label: "预计结款日期", minwidth: 120 },
        { keyName: "cmoney", label: "欠款金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "status", label: "状态", minwidth: 120 },
      ],
      getTotalProperty: ['cmoney'],
      btns: [
        // {
        //   icon: "el-icon-truck",
        //   title: "车辆运单",
        //   cb: ({ id }) => {
        //     this.$router.push(
        //       `/finance/vehicleOrder?id=${id}`
        //     );
        //   },
        // },
        {
          title: "运单列表",
          img: require('@/assets/img/icon_order.png'),
          unimg: require('@/assets/img/icon_order_hover.png'),
          cb: ({ id }) => {
            this.$router.push(
              `/finance/viewOrder?shipperid=${id}`
            );
          },
        },
        // {
        //   title: "合同补差",
        //   img: require('@/assets/img/icon_operate_11.png'),
        //   cb: ({ id }) => {
        //     this.$router.push(
        //       `/finance/contractFix?cid=${id}`
        //     );
        //   },
        // },
        {
          title: "还款记录",
          img: require('@/assets/img/pay_history.png'),
          unimg: require('@/assets/img/pay_history_hover.png'),
          cb: ({ id, name }) => {
            this.$router.push(
              `/finance/paymentHistory?shipperid=${id}&company=${name}`
            );
          },
        },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>

<style lang="less" scoped>
.main {
  .table-wrap {
    /deep/ .el-table {
      .overTime {
        // width: 14px;
        // height: 14px;
        // border-radius: 100%;
        // display: inline-block;
        // vertical-align: top;
        // margin-top: 7px;
        color: #ffe100;

        &.type1 {
          color: #98e098;
        }

        &.type2 {
          color: #fd5b5b;
        }
      }
    }
  }
}
</style>
